"use client";

// Per-account strategy-eligibility toggles on the Accounts page. An account
// must be tagged for a strategy to appear in that strategy's account dropdown.

export const STRATEGY_FLAGS: { key: string; label: string; title: string }[] = [
  { key: "vertical_spreads", label: "VIS", title: "Enable Vertical Index Spreads for this account" },
  { key: "vertical_spreads_0dte", label: "0VIS", title: "Enable 0DTE Vertical Index Spreads for this account" },
  { key: "vertical_spreads_equity", label: "VSS", title: "Enable Vertical Stock Spreads for this account" },
  { key: "covered_calls", label: "CC", title: "Enable Covered Calls for this account" },
  { key: "stock_trading", label: "ST", title: "Enable Stock Trading (view and close positions) for this account" },
  // threshold (TH) removed — strategy is defunct; keep off broker Options toggles
];

export function StrategyFlagButtons({
  accountHash,
  flags,
  onToggle,
}: {
  accountHash: string;
  /** Map of "accountHash:strategy" -> enabled. */
  flags: Record<string, boolean>;
  onToggle: (accountHash: string, strategy: string) => void;
}) {
  return (
    <div className="flex items-center gap-1">
      {STRATEGY_FLAGS.map((s) => {
        const enabled = flags[`${accountHash}:${s.key}`] ?? false;
        return (
          <button
            key={s.key}
            onClick={() => onToggle(accountHash, s.key)}
            className={`px-2 py-0.5 rounded text-xs font-medium border transition-colors ${
              enabled
                ? "bg-accent text-white border-transparent"
                : "bg-surface-light text-muted border-border hover:text-foreground"
            }`}
            title={s.title}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
